import { isFixRelayIdConflictInHelpCenter } from '@helpcenter/feature-flags';
import { fg } from '@atlaskit/platform-feature-flags';
import { createRelayEnvironment } from '@atlassian/relay-environment';

import RelayEnvironment from './environment';
import fetchOptions from './fetch-options';
import { QueryResponseCache } from './query-responses';
import { subscribeOptions } from './subscribe';

const sharedRelayEnvironment = createRelayEnvironment({
    ...(!isFixRelayIdConflictInHelpCenter() ? { getDataID: undefined } : {}),
    networkOptions: {
        setEndpoint: fetchOptions.setEndpoint,
        isServer: __SERVER__,
        subscribeExtensions: subscribeOptions.extensions,
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        onSubscribeError: subscribeOptions.onError,
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        onSubscribeTrigger: subscribeOptions.onTrigger,
        queryResponseCache: QueryResponseCache,
    },
});

export const getRelayEnvironment = () => {
    if (fg('platform_relay_use_shared_relay_env_help_center')) {
        return sharedRelayEnvironment;
    }

    return RelayEnvironment;
};

export { getRelayDataId } from './data-id';
